/*
 * Copyright (c) 2025.
 * This code and its derivatives belong to BETICA LTD and may not be copied, reproduced, amended or used in any way without the permission of BETICA LTD
 * @author torrejonv
 *
 */

/**
 * @file bettype-selector.js
 * @description Redux selectors for accessing bettype state data
 */

import {createSelector} from "@reduxjs/toolkit";

/**
 * @function getBetTypeSelector
 * @description Selector that returns the bet type data from state
 * @param {Object} state - Redux state
 * @returns {Array} Bet types array
 */
export const getBetTypeSelector = (state) => state.betType?.betTypes || [];
